import { render, staticRenderFns } from "./SellerBuyReports.vue?vue&type=template&id=6cd8c895&"
import script from "./SellerBuyReports.vue?vue&type=script&lang=js&"
export * from "./SellerBuyReports.vue?vue&type=script&lang=js&"
import style0 from "./SellerBuyReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports